import React from "react"

type PillProps = {
  text: string | JSX.Element
  color?: "yellow" | "gray"
}
export const Pill = ({ text, color = "yellow" }: PillProps) => {
  const colorClass = {
    yellow: "bg-yellow-500 shadow-md",
    gray: "bg-gray-50",
  }[color]
  return (
    <span
      className={`${colorClass} rounded-md uppercase text-xs font-medium tracking-wide px-3 py-2 `}
    >
      {text}
    </span>
  )
}
